import React from 'react';
import AutoRules from '../AutoRules';
import { SectionShell } from './_shared';

export default function AutomationSection() {
  return (
    <SectionShell eyebrow="Automation" title="Automation rules" description="Clasifi auto-categorizes new receipts when it sees a recurring vendor pattern." testid="section-automation">
      <AutoRules />
    </SectionShell>
  );
}
